<app-breadcrumb [master]="'Administracja'" [parentName]="'Adresy'"  [name]="'Lista '"></app-breadcrumb>
<div class="row-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="row-list-filters">
    <mat-form-field class="row-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Siedlce" name="contains$value" [(ngModel)]="initialFilters.contains$value">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_import_type'"
      [skipKeys]="['city']"
      [label]="'Typ'" class="row-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

  </form>

  <div class="row-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="addressRow">


    <ng-container matColumnDef="typ" >
      <th mat-header-cell *matHeaderCellDef > Typ
      <td mat-cell *matCellDef="let element" >
        {{element.type.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        {{element.value}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
